import Block from "@ludens-reklame/rubics-theme/dist/components/Block";

export default Block;
